import React, { createContext, FC, useCallback, useEffect, useState } from 'react';

import i18n, { Scope, TranslateOptions } from 'i18n-js';

import { LanguageTags } from 'shared/constants';
import { pluralizeForRussian } from './helper';

// import ru from './locales/ru.json';
// import en from './locales/en.json';
// import id from './locales/id.json';

// const translations = {
//   ru,
//   en,
//   id,
// };

let LangDetected: LanguageTags | null = null;

// @ts-ignore
const translations = window.langs as { [key: string]: { key: string; value: string }[] };

//@ts-ignore
window.langLoaded = (data, tag) => {
  translations[tag] = data;
  changeLanguage(getLanguage());
};

export function getNativeLanguage(): LanguageTags {
  let languageTag: any = LanguageTags.en;
  if (navigator.language) {
    const tag = navigator.language.substring(0, 2).toLowerCase();
    if (Object.keys(LanguageTags).includes(tag)) {
      languageTag = tag;
    }
  }
  return languageTag;
}

export function getLanguage(): LanguageTags {
  const localStorageLang = localStorage.getItem('lang');
  if (localStorageLang) {
    return localStorageLang as LanguageTags;
  }

  if (LangDetected !== null) {
    return LangDetected;
  }

  const languageTag = getNativeLanguage();
  LangDetected = languageTag;

  return languageTag;
}

export type TranslatorFunc = (scope: Scope, options?: TranslateOptions) => string;

export const TranslatorContext = createContext({
  t: (scope: Scope, options?: TranslateOptions) => i18n.t(scope, options),
  lang: getLanguage(),
});

export const changeLanguage = async (lang: string) => {
  localStorage.setItem('lang', lang);

  if (!translations[lang]) {
    try {
      const response = await fetch('https://api.tonplace.net/lang/json', {
        headers: {
          'Accept-Language': lang,
        },
      });
      translations[lang] = await response.json();
    } catch (e) {
      console.log(e);
    }
  }
  dispatchEvent(new CustomEvent('langChange', { detail: { lang } }));
};

export const TranslatorProvider: FC = ({ children }) => {
  const [hasLangChanged, setHasLangChanged] = useState(false);

  const t: TranslatorFunc = useCallback(
    (scope, options?) =>
      i18n.t(scope, {
        ...options,
        // defaultValue: '-'
      }),
    [hasLangChanged],
  );

  const setI18nConfig = useCallback(() => {
    const languageTag = getLanguage();

    let keys = translations[languageTag];
    if (languageTag !== LanguageTags.en || !translations[languageTag]) {
      keys = {
        ...(translations[Object.keys(translations)[0]] || translations[LanguageTags.en]),
        ...keys,
      };
    }

    i18n.translations = {
      [languageTag]: keys,
    };
    i18n.locale = languageTag;

    setHasLangChanged((prev) => !prev);
  }, []);

  useEffect(() => {
    const languageTag = getLanguage();
    setI18nConfig();
    addEventListener('langChange', setI18nConfig);

    if (!translations[languageTag]) {
      changeLanguage(languageTag);
    }

    return () => removeEventListener('langChange', setI18nConfig);
  }, []);

  return (
    <TranslatorContext.Provider value={{ t, lang: getLanguage() }}>
      {children}
    </TranslatorContext.Provider>
  );
};

i18n.pluralization.ru = pluralizeForRussian;
